import { axios } from "@LIBS";
import { Constants } from "@CONFIG";
const ProductEndpoints = {
  listProducts: "api/products",
};
const createProduct = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/products`,
    method: "POST",
    data: values,
  });

  return response;
};

const updateProduct = async (values, id) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/products/${id}`,
    method: "PUT",
    data: values,
  });

  return response;
};

const deleteProduct = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/products`,
    data: {
      productIds: values,
    },
    method: "DELETE",
  });

  return response;
};

const deleteAllProducts = async () => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/products/delete-all`,
    method: "DELETE",
  });

  return response;
};

const uploadExcel = async (values) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/products/upload`,
    method: "POST",
    data: values,
  });

  return response;
};

const getAllProducts = async () => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/products/get-all-products`,
    method: "GET",
  });

  return response;
};

const getProductsByCodes = async (codes) => {
  const response = await axios({
    url: `${Constants.BACKEND_API_URL}/api/products/match-by-codes`,
    method: "POST",
    data: { codes },
  });

  return response;
};

export {
  createProduct,
  uploadExcel,
  ProductEndpoints,
  deleteProduct,
  updateProduct,
  deleteAllProducts,
  getAllProducts,
  getProductsByCodes,
};
